import script from "./Template1.vue?vue&type=script&setup=true&lang=js"
export * from "./Template1.vue?vue&type=script&setup=true&lang=js"

import "./Template1.vue?vue&type=style&index=0&id=fc82bf4c&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_typescript@4.9.5__webpack@5.112.2_2b87b21da4aed600185acfcb8e880229/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc82bf4c"]])

export default __exports__